import { useTheme } from '@mui/material/styles'
import { HiOutlineSparkles } from 'react-icons/hi2'
import type { IconBaseProps } from 'react-icons/lib'

const AIIcon = (props: IconBaseProps) => {
	const {
		palette: {
			ai: { main: aiColor },
		},
	} = useTheme()

	return <HiOutlineSparkles size={16} color={aiColor} {...props} />
}

export { AIIcon }
